var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kd-image-effects__item",class:[
    _vm.itemClassWithId,
    { 'kd-image-effects__item--active': _vm.isActive }
  ],on:{"click":_vm.onCLick}},[_c('div',{staticClass:"kd-image-effects__thumb"},[_c('div',{staticClass:"kd-image-effects__thumb-image",style:({ backgroundImage: _vm.backgroundImageCss })})]),_c('div',{staticClass:"kd-image-effects__label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }